
import { useEffect, useState } from 'react';

export default function ParallaxBackground() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed inset-0 z-0">
      {/* First background layer - moves slower */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Futuristic%20cybersecurity%20digital%20landscape%20with%20glowing%20network%20nodes%2C%20dark%20blue%20gradient%20background%2C%20abstract%20data%20streams%20flowing%20vertically%2C%20high-tech%20security%20elements%2C%20minimalist%20design%20with%20subtle%20grid%20patterns%20and%20holographic%20effects%2C%204K%20vertical%20composition%20perfect%20for%20parallax%20scrolling&width=1920&height=3840&seq=bg1&orientation=portrait')`,
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      />
      
      {/* Second background layer - moves faster in opposite direction */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20cybersecurity%20matrix%20with%20floating%20binary%20code%2C%20neon%20blue%20and%20purple%20gradients%2C%20digital%20security%20shields%20and%20lock%20symbols%2C%20vertical%20flowing%20data%20streams%2C%20dark%20background%20with%20glowing%20particles%2C%20high-tech%20aesthetic%2C%204K%20portrait%20orientation%20for%20web%20parallax&width=1920&height=3840&seq=bg2&orientation=portrait')`,
          transform: `translateY(${scrollY * -0.3}px)`,
        }}
      />

      {/* Third background layer - subtle overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-15"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Sophisticated%20network%20security%20visualization%20with%20interconnected%20nodes%2C%20dark%20navy%20blue%20background%2C%20subtle%20geometric%20patterns%2C%20floating%20digital%20security%20elements%2C%20professional%20cybersecurity%20aesthetic%2C%20vertical%204K%20composition%20with%20smooth%20gradients%20and%20minimal%20visual%20noise&width=1920&height=3840&seq=bg3&orientation=portrait')`,
          transform: `translateY(${scrollY * 0.2}px)`,
        }}
      />

      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/60 to-slate-900/80" />
    </div>
  );
}
